export default __webpack_public_path__ + "static/media/misc-pantry2-480w.c206c53a.webp";